import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { ImportReviewParams } from '../../params/redux/review';
import { isErrorWithMessage } from '../../helper';
import { resettingReviewLoader } from '../slices/review';
import ReviewApi from '../../apis/review';
import { RootState } from '../store';

export const fetchReviewsThunk = createAsyncThunk(
    'review/fetch',
    async (client_id: number, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReviewApi.fetchReviews(state.app.token, client_id);
            if (response?.success === 1) {
                return response.businesses;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReviewLoader());
        }
    }
);

export const importReviewsThunk = createAsyncThunk(
    'review/import',
    async ({ data, client_id }: {data: ImportReviewParams[], client_id: number}, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const data1 = {
                data,
                client_id
            };
            const response = await ReviewApi.importReviews(state.app.token, data1);
            if (response?.success === 1) {
                await dispatch(fetchReviewsThunk(client_id)).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReviewLoader());
        }
    }
);

export const searchBusinessReviewsThunk = createAsyncThunk(
    'review/reviews-business',
    async (value: string, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReviewApi.searchBusinessReviews(state.app.token, value);
            if (response?.success === 1) {
                return response.businesses;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReviewLoader());
        }
    }
);

export const fetchBusinessRequestsThunk = createAsyncThunk(
    'review/requests-business',
    async (client_id: number, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReviewApi.fetchRequests(state.app.token, client_id);
            if (response?.success === 1) {
                return response.businesses;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReviewLoader());
        }
    }
);